export default "__VITE_ASSET__7e41aa51__"